


















import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { IMenuItem, IMenuLink } from "../..";

@Component({})
export default class EventslPanel extends Vue {
    @Prop({ required: true }) public caption: string;
    @Prop({ default: () => [] }) public items: IMenuItem[];

    additionalClassesForItem(item: IMenuLink){
        return {
            ['sip-modal']: !!item?.modal,
            ['sip-link']: !!item,
        }
    }

    navigateAction(e: Event, item: IMenuLink) {
        if (!!item?.modal) {
            e.preventDefault();
            this.navigate(e);
        }
    }

    @Emit('navigate') public navigate(e: Event) { return e; }
}
